import { render, staticRenderFns } from "./DeleteHub.vue?vue&type=template&id=0997ba6e"
import script from "./DeleteHub.vue?vue&type=script&lang=js"
export * from "./DeleteHub.vue?vue&type=script&lang=js"
import style0 from "./DeleteHub.vue?vue&type=style&index=0&id=0997ba6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports